import { useTranslation } from "../i18n";
import TotesAdmin from "../components/TotesAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

const AdminTotes = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="totes_settings"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "totes_settings" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("totes_settings_hint")}</p>
                <TotesAdmin />
            </div>
        </div>
    );
};

export default AdminTotes;
